export const STORAGE_MANAGER_PREFIX = 'atlassian';
export const STORAGE_MANAGER_ID = 'frontend';
export const LOCAL_STORAGE_MANAGER = 'localStorage';
export const SESSION_STORAGE_MANAGER = 'sessionStorage';
